module.exports = __webpack_public_path__ + "static/media/step4.b83e9359.png";


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfCommon/Pay3/images/sber/step4.png
// module id = 706
// module chunks = 0